import React,{useState} from "react";
import { Link } from "react-router-dom";

import germany from '../assets/images/flags/germany.png'
import india from '../assets/images/flags/india.png'
import italy from '../assets/images/flags/italy.png'
import russia from '../assets/images/flags/russia.png'
import spain from '../assets/images/flags/spain.png'
import usa from '../assets/images/flags/usa.png'
import videoImg from "../assets/images/modern.mp4"

import {FiCheckCircle} from '../assets/icons/vander'

import ModalVideo from 'react-modal-video';
import '../../node_modules/react-modal-video/css/modal-video.css'
import aboutImg from "../assets/images/features/about-3.png"

export default function AboutThree(){
    const [isOpen, setOpen] = useState(false);
    const countryData = [
        {
            name:"Italian",
            image:italy
        },
        {
            name:"Hindi",
            image:india
        },
        {
            name:"Russian",
            image:russia
        },
        {
            name:"Spanish",
            image:spain
        },
        {
            name:"English",
            image:usa
        },
    ]
    return(
        <>
        <div className="container relative md:mt-24 mt-16">
                <div className="grid md:grid-cols-2 grid-cols-1 items-center gap-6">
                    <div className="relative order-1 md:order-2">
                        <div className="relative overflow-hidden rounded-lg  ps-6 pt-6 lg:me-8">
                            <img src={aboutImg} className="ltr:rounded-tl-lg rtl:rounded-tr-lg" alt=""/>
                        </div>
                    </div>

                    <div className="">
                        <h3 className="mb-4 md:text-3xl md:leading-normal text-2xl leading-normal font-semibold">Stay Ahead with New and Trending AI Products</h3>
                        <p className="text-slate-400 max-w-xl">In the fast-paced world of AI, staying updated is crucial. Our platform keeps you informed about the latest innovations, helping your product stand out and stay competitive.</p>

                        <ul className="list-none text-slate-400 mt-4">
                            <li className="mb-2 flex items-center"><FiCheckCircle className="text-amber-400 h-5 w-5 me-2"/> Spot Emerging Trends</li>
                            <li className="mb-2 flex items-center"><FiCheckCircle className="text-amber-400 h-5 w-5 me-2"/> Stay Informed, Stay Competitive</li>
                            <li className="mb-2 flex items-center"><FiCheckCircle className="text-amber-400 h-5 w-5 me-2"/> Track the popularity of AI tools</li>
                        </ul>

                    </div>
                </div>
            </div>
        
        </>
    )
}